import { render } from "./BlockedRecipientsList.vue?vue&type=template&id=159db384"
import script from "./BlockedRecipientsList.vue?vue&type=script&lang=js"
export * from "./BlockedRecipientsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__